import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import RichText from "@/components/RichText";

// Chaque bloc "collection_item" (theme_service.BLOCK_TYPES["collection_list"])
// référence une catégorie par son slug — un seul appel /categories pour
// résoudre tous les blocs, quel que soit leur nombre.
export default function CollectionListSection({ props = {}, blocks = [] }) {
  const items = (blocks || []).filter((b) => b.enabled !== false && b.type === "collection_item" && b.props?.collection_id);
  const [categories, setCategories] = useState(null);

  useEffect(() => {
    if (!items.length) return;
    let cancelled = false;
    api.get("/categories").then(({ data }) => { if (!cancelled) setCategories(data || []); }).catch(() => { if (!cancelled) setCategories([]); });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blocks.length]);

  if (!items.length) return null;

  const lgCols = items.length === 3 ? "lg:grid-cols-3" : items.length <= 2 ? "lg:grid-cols-2" : "lg:grid-cols-4";

  return (
    <section id={props.anchor_id || undefined} className="max-w-[1240px] mx-auto px-6 md:px-10 py-section md:py-section-md">
      {props.heading && (
        <RichText
          as="h2"
          className="font-display font-semibold text-[28px] md:text-[32px] leading-tight tracking-[-0.02em] text-ink mb-8"
          html={props.heading}
        />
      )}
      <div className={`grid sm:grid-cols-2 ${lgCols} gap-5`}>
        {items.map((block) => {
          const cat = (categories || []).find((c) => c.slug === block.props.collection_id);
          if (!cat) return null;
          return (
            <Link
              key={block.id}
              data-block-key={block.id}
              to={`/categorie/${cat.slug}`}
              className="group relative rounded-2xl overflow-hidden bg-sand aspect-[4/5]"
            >
              {cat.image && (
                <img src={cat.image} alt="" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-ink/60 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <h3 className="font-display font-semibold text-[18px] text-white">{cat.name}</h3>
                {typeof cat.count === "number" && (
                  <p className="text-[12px] text-white/70 mt-0.5">{cat.count} pièce{cat.count !== 1 ? "s" : ""}</p>
                )}
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
